"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const mirror = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-mirror` : '') + (description ? ` desc-mirror` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-mirror"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-mirror"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_24792_8500)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 .03a10.5 10.5 0 0 1 5.66 19.35.75.75 0 0 1-.81-1.26 9 9 0 1 0-9.7 0 .75.75 0 0 1-.8 1.26A10.5 10.5 0 0 1 12 .03Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.19 19.5c-.15.24-.38.58-.66.86-.25.26-.7.64-1.28.64h-4.5c-.58 0-1.03-.38-1.28-.64-.28-.28-.5-.62-.65-.86H1.5v.75a2.25 2.25 0 0 0 2.25 2.25h16.5l.22-.01a2.25 2.25 0 0 0 2.03-2.24v-.75h-6.31Zm7.81.75A3.75 3.75 0 0 1 20.25 24H3.75A3.75 3.75 0 0 1 0 20.25v-.75A1.5 1.5 0 0 1 1.5 18h6.32c.19 0 .37.03.55.1l.17.08.16.1c.1.08.2.17.27.26l.12.16c.12.2.28.44.45.62a1.05 1.05 0 0 0 .24.18h4.45l.02-.01.2-.17c.18-.18.34-.41.46-.62.14-.22.33-.4.55-.52l.18-.08c.17-.07.36-.1.55-.1h6.31a1.5 1.5 0 0 1 1.5 1.5v.75Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 10.5a6 6 0 1 0-12 0 6 6 0 0 0 12 0Zm1.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_24792_8500"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = mirror;